<template>
  <b-modal
      :title="$t('history.modal.header.TransferToInvoicing')"
      ref="invocing-transfer-modal"
      @ok="doTransfer"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="cancel()">Cancel</b-button>
      <b-button @click="ok()" name="transferToInvoicingModalButton" variant="primary">{{
          $t('history.modal.button.Transfer')
        }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import {CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX} from '@/store/constants';
import helpers from '@/helper';
import {mapGetters} from 'vuex';
import vSelect from '../../vSelect';

export default {
  props: {
    deliveryStatus: {type: String}
  },

  components: {
    vSelect
  },

  data() {
    return {};
  },

  computed: {
    ...mapGetters('history', ['getSelectedRows', 'getDeliverStatusesWithoutUndelivered'])
  },

  methods: {
    showCargoWiseTransferModal() {
      this.$refs['invocing-transfer-modal'].show();
    },

    doTransfer() {
      this.$emit('transferShipmentToInvoicing');
      
    }
  }
};
</script>

<style></style>
